import React, { useRef, useContext, useEffect } from "react";
import { CanvasContext } from "./CanvasContext";
import { fabric } from "fabric";
import { useSelector } from "react-redux";

export const GridCanvas = () => {
  const gridCanvasRef = useRef(null);
  const bottomBarExpanded = useSelector((state) => state.ui.bottomBarExpanded);

  const { canvas } = useContext(CanvasContext);
  const height = canvas?.getHeight();
  const width = canvas?.getWidth();

  useEffect(() => {
    // Grid canvas
    const gridCanvas = new fabric.StaticCanvas(gridCanvasRef.current);

    // Function to draw grid on the grid canvas
    const drawGrid = () => {
      const gridSize = 20; // Adjust the grid size as needed

      // Clear existing objects on the grid canvas
      gridCanvas.clear();

      // Draw vertical grid lines
      for (let i = gridSize; i < gridCanvas.width; i += gridSize) {
        gridCanvas.add(
          new fabric.Line([i, 0, i, gridCanvas.height], {
            stroke: "#ccc",
            selectable: false,
          })
        );
      }

      // Draw horizontal grid lines
      for (let j = gridSize; j < gridCanvas.height; j += gridSize) {
        gridCanvas.add(
          new fabric.Line([0, j, gridCanvas.width, j], {
            stroke: "#ccc",
            selectable: false,
          })
        );
      }
    };

    // Initial draw of the grid
    drawGrid();

    // Handle canvas resize
    const handleResize = () => {
      // Ensure canvasDimensions and bottomBarExpanded are updated in Redux
      // const newWidth = width;
      // const newHeight = height;

      // Update grid canvas dimensions
      gridCanvas.setDimensions({
        width: width,
        height: height,
      });

      // Redraw the grid
      drawGrid();
    };
    handleResize();

    // Attach resize event listener
    window.addEventListener("resize", handleResize);

    // Cleanup function
    return () => {
      window.removeEventListener("resize", handleResize);
      gridCanvas.dispose();
    };
  }, [height, width, bottomBarExpanded]);

  return (
    <canvas
      ref={gridCanvasRef}
      width={width}
      height={height}
      style={{ position: "absolute", zIndex: 1 }}
    />
  );
};
